/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineResponse403,
    InlineResponse403FromJSON,
    InlineResponse403ToJSON,
    Payment,
    PaymentFromJSON,
    PaymentToJSON,
    PaymentConfirmRestRequest,
    PaymentConfirmRestRequestFromJSON,
    PaymentConfirmRestRequestToJSON,
    PaymentDataFrame,
    PaymentDataFrameFromJSON,
    PaymentDataFrameToJSON,
} from '../models';

export interface ApiPaymentsConfirmFormPostRequest {
    p24MerchantId?: string;
    p24PosId?: string;
    p24SessionId?: string;
    p24Amount?: string;
    p24OriginAmount?: string;
    p24Currency?: string;
    p24OrderId?: string;
    p24MethodId?: string;
    p24Statement?: string;
    p24Sign?: string;
}

export interface ApiPaymentsConfirmRestPostRequest {
    paymentConfirmRestRequest?: PaymentConfirmRestRequest;
}

export interface ApiPaymentsGetRequest {
    relations?: string;
    deleted?: boolean;
    filtering?: string;
    offset?: number;
    limit?: number;
    order?: string;
}

export interface ApiPaymentsIdDeleteRequest {
    id: number;
}

export interface ApiPaymentsIdGetRequest {
    id: number;
    relations?: string;
    deleted?: boolean;
}

export interface ApiPaymentsPostRequest {
    relations?: string;
    deleted?: boolean;
    payment?: Payment;
}

/**
 * no description
 */
export class PaymentApi extends runtime.BaseAPI {

    /**
     * Receive payment confirmation
     */
    async apiPaymentsConfirmFormPostRaw(requestParameters: ApiPaymentsConfirmFormPostRequest): Promise<runtime.ApiResponse<Payment>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.p24MerchantId !== undefined) {
            formParams.append('p24_merchant_id', requestParameters.p24MerchantId as any);
        }

        if (requestParameters.p24PosId !== undefined) {
            formParams.append('p24_pos_id', requestParameters.p24PosId as any);
        }

        if (requestParameters.p24SessionId !== undefined) {
            formParams.append('p24_session_id', requestParameters.p24SessionId as any);
        }

        if (requestParameters.p24Amount !== undefined) {
            formParams.append('p24_amount', requestParameters.p24Amount as any);
        }

        if (requestParameters.p24OriginAmount !== undefined) {
            formParams.append('p24_origin_amount', requestParameters.p24OriginAmount as any);
        }

        if (requestParameters.p24Currency !== undefined) {
            formParams.append('p24_currency', requestParameters.p24Currency as any);
        }

        if (requestParameters.p24OrderId !== undefined) {
            formParams.append('p24_order_id', requestParameters.p24OrderId as any);
        }

        if (requestParameters.p24MethodId !== undefined) {
            formParams.append('p24_method_id', requestParameters.p24MethodId as any);
        }

        if (requestParameters.p24Statement !== undefined) {
            formParams.append('p24_statement', requestParameters.p24Statement as any);
        }

        if (requestParameters.p24Sign !== undefined) {
            formParams.append('p24_sign', requestParameters.p24Sign as any);
        }

        const response = await this.request({
            path: `/api/payments/confirm/form`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentFromJSON(jsonValue));
    }

    /**
     * Receive payment confirmation
     */
    async apiPaymentsConfirmFormPost(p24MerchantId?: string, p24PosId?: string, p24SessionId?: string, p24Amount?: string, p24OriginAmount?: string, p24Currency?: string, p24OrderId?: string, p24MethodId?: string, p24Statement?: string, p24Sign?: string): Promise<Payment> {
        const response = await this.apiPaymentsConfirmFormPostRaw({ p24MerchantId: p24MerchantId, p24PosId: p24PosId, p24SessionId: p24SessionId, p24Amount: p24Amount, p24OriginAmount: p24OriginAmount, p24Currency: p24Currency, p24OrderId: p24OrderId, p24MethodId: p24MethodId, p24Statement: p24Statement, p24Sign: p24Sign });
        return await response.value();
    }

    /**
     * Receive payment confirmation
     */
    async apiPaymentsConfirmRestPostRaw(requestParameters: ApiPaymentsConfirmRestPostRequest): Promise<runtime.ApiResponse<Payment>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/payments/confirm/rest`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PaymentConfirmRestRequestToJSON(requestParameters.paymentConfirmRestRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentFromJSON(jsonValue));
    }

    /**
     * Receive payment confirmation
     */
    async apiPaymentsConfirmRestPost(paymentConfirmRestRequest?: PaymentConfirmRestRequest): Promise<Payment> {
        const response = await this.apiPaymentsConfirmRestPostRaw({ paymentConfirmRestRequest: paymentConfirmRestRequest });
        return await response.value();
    }

    /**
     * Get list of Payment
     */
    async apiPaymentsGetRaw(requestParameters: ApiPaymentsGetRequest): Promise<runtime.ApiResponse<PaymentDataFrame>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        if (requestParameters.filtering !== undefined) {
            queryParameters['filtering'] = requestParameters.filtering;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/payments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentDataFrameFromJSON(jsonValue));
    }

    /**
     * Get list of Payment
     */
    async apiPaymentsGet(relations?: string, deleted?: boolean, filtering?: string, offset?: number, limit?: number, order?: string): Promise<PaymentDataFrame> {
        const response = await this.apiPaymentsGetRaw({ relations: relations, deleted: deleted, filtering: filtering, offset: offset, limit: limit, order: order });
        return await response.value();
    }

    /**
     * Remove entity of Payment
     */
    async apiPaymentsIdDeleteRaw(requestParameters: ApiPaymentsIdDeleteRequest): Promise<runtime.ApiResponse<Payment>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiPaymentsIdDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/payments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentFromJSON(jsonValue));
    }

    /**
     * Remove entity of Payment
     */
    async apiPaymentsIdDelete(id: number): Promise<Payment> {
        const response = await this.apiPaymentsIdDeleteRaw({ id: id });
        return await response.value();
    }

    /**
     * Get entity of Payment
     */
    async apiPaymentsIdGetRaw(requestParameters: ApiPaymentsIdGetRequest): Promise<runtime.ApiResponse<Payment>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiPaymentsIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/payments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentFromJSON(jsonValue));
    }

    /**
     * Get entity of Payment
     */
    async apiPaymentsIdGet(id: number, relations?: string, deleted?: boolean): Promise<Payment> {
        const response = await this.apiPaymentsIdGetRaw({ id: id, relations: relations, deleted: deleted });
        return await response.value();
    }

    /**
     * Create or update entity of Payment (if id defined)
     */
    async apiPaymentsPostRaw(requestParameters: ApiPaymentsPostRequest): Promise<runtime.ApiResponse<Payment>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/payments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PaymentToJSON(requestParameters.payment),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentFromJSON(jsonValue));
    }

    /**
     * Create or update entity of Payment (if id defined)
     */
    async apiPaymentsPost(relations?: string, deleted?: boolean, payment?: Payment): Promise<Payment> {
        const response = await this.apiPaymentsPostRaw({ relations: relations, deleted: deleted, payment: payment });
        return await response.value();
    }

}
